import * as React from 'react';
import {
  getMeta,
  Plugins,
  Types,
  TypeImplementation,
} from '@packages/systems/wfdl';
import {
  ExpressionEditor,
  updateExpressionAction,
} from '@packages/systems/ExpressionEditor-utils';
import {emotionStyled} from '@packages/utilities/styled';
import {FormLabel, Switch} from '@packages/systems/spring';

import {TBoolean, EBoolean} from '@packages/systems/wfdl-ast';

import {
  ContextualExpressions,
  stripAnn,
  getAnn,
} from '@packages/utilities/contextual-expression';

const Wrapper = emotionStyled('div')({
  display: 'flex',
  height: 30,
  paddingLeft: '$2',
  paddingRight: '$2',
  alignItems: 'center',
  justifyContent: 'space-between',
  backgroundColor: '$background1',
  border: '$border1',
  borderRadius: '$2',
});

const StyledFormLabel = emotionStyled(FormLabel)({
  display: 'flex',
  alignItems: 'center',
  gap: '$1',
});

export const SwitchLabelType = TypeImplementation.Alias({
  type: TBoolean,
  render: ({expr, dispatch}) => {
    const strippedExpr = stripAnn(expr);
    const boolean = ContextualExpressions.getBoolean(strippedExpr);

    const {type} = getAnn(expr);

    if (type === null) {
      throw Error('Expected type from AnnotatedExpression to be defined');
    }

    const label = Types.getLabel(type);
    const meta = getMeta(type);
    const metaIcon = meta?.icon;
    const icon = Array.isArray(metaIcon) ? (
      // @ts-expect-error - TS2322 - Type 'any[]' is not assignable to type 'QualifiedPluginIcon'.
      <Plugins.PluginIcon icon={metaIcon} />
    ) : (
      metaIcon
    );

    if (boolean !== null) {
      const uiValue = meta?.isOpposite ? !boolean : boolean;
      const toggleSwitchState = () => {
        dispatch(updateExpressionAction(EBoolean(!boolean)));
      };

      return (
        <Wrapper>
          <StyledFormLabel htmlFor="element-toggle-switch">
            {icon}
            {label}
          </StyledFormLabel>
          <Switch
            id="element-toggle-switch"
            isChecked={uiValue}
            density="compact"
            aria-label="Element toggle switch"
            onChange={toggleSwitchState}
          ></Switch>
        </Wrapper>
      );
    } else {
      return <ExpressionEditor expression={expr} dispatch={dispatch} />;
    }
  },
});
